<template>
    <div>CASHIER REMITTANCE</div>
</template>